import React from "react";
import { Image } from "react-bootstrap";

// Bank card choice of the subscription windows, next to Orange and MTN
function CardPaymentTile({ selected, onSelect }) {
  return (
    <button
      type="button"
      onClick={onSelect}
      title="Carte bancaire (Visa, Mastercard)"
      aria-pressed={selected}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "4px",
        width: "70px",
        height: "70px",
        padding: 2,
        background: "#fff",
        borderRadius: "8px",
        border: selected ? "3px solid #FF5500" : "1px solid #ccc",
      }}
    >
      <span style={{ display: "flex", gap: "3px" }}>
        <Image
          src="/images/payment/visa.png"
          alt=""
          style={{ width: "28px", height: "20px", objectFit: "contain" }}
        />
        <Image
          src="/images/payment/mastercard.jpg"
          alt=""
          style={{ width: "28px", height: "20px", objectFit: "contain" }}
        />
      </span>
      <span style={{ fontSize: "11px", fontWeight: 600, color: "#051259" }}>
        Carte
      </span>
    </button>
  );
}

// Tells the client what paying by card implies before he is redirected
export function CardPaymentNote({ feePercent }) {
  return (
    <p style={{ fontSize: "13px", color: "#5b6275", marginBottom: 0 }}>
      Vous saisirez votre carte sur la page sécurisée de notre partenaire de
      paiement.
      {feePercent > 0
        ? ` Des frais de paiement par carte de ${String(feePercent).replace(
            ".",
            ",",
          )} % s'ajoutent au montant.`
        : " Des frais de paiement par carte peuvent s'ajouter au montant total."}
    </p>
  );
}

export default CardPaymentTile;
